import { render } from "./SatisfactionScale.vue?vue&type=template&id=7368c088&scoped=true"
import script from "./SatisfactionScale.vue?vue&type=script&lang=js"
export * from "./SatisfactionScale.vue?vue&type=script&lang=js"

import "./SatisfactionScale.vue?vue&type=style&index=0&id=7368c088&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-nps\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7368c088"]])

export default __exports__